import { render, staticRenderFns } from "./FlightsDashboardHistorical.vue?vue&type=template&id=3001ce5f&"
import script from "./FlightsDashboardHistorical.vue?vue&type=script&lang=js&"
export * from "./FlightsDashboardHistorical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports